export var RED = '#f44';
export var BLUE = '#1989fa';
export var GREEN = '#07c160';
export var WHITE = '#fff';
export var GRAY = '#c9c9c9';
export var GRAY_DARK = '#969799';